import apiClient from './api';

// CRM API (staff JWT): customer 360 profiles plus the five growth reports.
const crmService = {
  profileByPhone: async (phone) => {
    const { data } = await apiClient.get('/customers/crm/profile/', { params: { phone } });
    return data.data;
  },
  // Put a guest on the blacklist or lift it; returns the refreshed profile.
  setBlacklist: async (id, blacklisted, reason = '') => {
    const { data } = await apiClient.post(`/customers/crm/profile/${id}/blacklist/`, { blacklisted, reason });
    if (!data?.success) throw new Error(data?.error || 'Could not update the blacklist.');
    return data.data;
  },
  // Staff notes on the guest; both return the refreshed profile.
  addNote: async (id, text, kind = 'NOTE') => {
    const { data } = await apiClient.post(`/customers/crm/profile/${id}/notes/`, { text, kind });
    if (!data?.success) throw new Error(data?.error || 'Could not save the note.');
    return data.data;
  },
  deleteNote: async (id, noteId) => {
    const { data } = await apiClient.delete(`/customers/crm/profile/${id}/notes/${noteId}/`);
    if (!data?.success) throw new Error(data?.error || 'Could not remove the note.');
    return data.data;
  },
  profileById: async (id) => {
    const { data } = await apiClient.get(`/customers/crm/profile/${id}/`);
    return data.data;
  },
  rfm: async () => {
    const { data } = await apiClient.get('/customers/crm/reports/rfm/');
    return data.data;
  },
  topCustomers: async (limit = 50) => {
    const { data } = await apiClient.get('/customers/crm/reports/top-customers/', { params: { limit } });
    return data.data;
  },
  retention: async (months = 12) => {
    const { data } = await apiClient.get('/customers/crm/reports/retention/', { params: { months } });
    return data.data;
  },
  menuAffinity: async (limit = 25) => {
    const { data } = await apiClient.get('/customers/crm/reports/menu-affinity/', { params: { limit } });
    return data.data;
  },
  churnRisk: async (limit = 100) => {
    const { data } = await apiClient.get('/customers/crm/reports/churn-risk/', { params: { limit } });
    return data.data;
  },
};

export default crmService;
